import { css } from 'styled-components';
import { AA_LINK_ON_LIGHT, AA_SURFACE } from '~/modules/Helper/contrast.helper';

/**
 * Identidade única dos chips do banner (menu à esquerda, acessibilidade à direita).
 * Alterar `borda` aqui aplica a grossura do recorte nos dois cantos.
 */
export const HEADER_BANNER_CHIP = {
  tamanho: 44,
  borda: 4,
  raio: 8,
  corFundoPagina: '#f5f5f5',
};

export function corRecorteBanner(theme) {
  if (theme && theme.highContrast) {
    return '#000';
  }
  return HEADER_BANNER_CHIP.corFundoPagina;
}

export const headerBannerChipBase = css`
  box-sizing: content-box;
  position: absolute;
  top: 0;
  z-index: 3;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: ${HEADER_BANNER_CHIP.tamanho}px;
  background: var(--header-chip-bg, ${AA_LINK_ON_LIGHT});
  color: ${AA_SURFACE};
  border-style: solid;
  border-color: ${({ theme }) => corRecorteBanner(theme)};
  border-width: 0;
  overflow: visible;
`;
